import React from "react";
import { useNavigate } from "react-router-dom";

function Landingpage() {
  const navigate = useNavigate();

  const createAccount = () => {
    navigate("/signup");
  };

  const explorePage = () => {
    navigate("/explore");
  };
  return (
    <section>
      <div className="d-flex adjustLanding justify-content-between align-items-lg-center pt100 pb-3">
        <div className="landingDesc">
          <h1>
            <span className="pe-md-4 pe-3">Jolly</span>MARKETPLACE
          </h1>
          <h1>YOUR PLACE FOR</h1>
          <h1>
            <span>DIGITAL TATTOOS</span>
          </h1>
          <p className="pt-2">
            JOLLY is the world's first and largest NFT marketplace
          </p>
          <div className="d-flex gap-3 pt-sm-3 pt-1 ">
            <button 
              className="explore text-uppercase"
              onClick={() => explorePage()}
            >
              {" "}
              Explore
            </button>
            <a
              className="Create textSize"
              // dangerouslySetInnerHTML
              href="javascript:void(0)"
              onClick={() => createAccount()}
            >
              Create
            </a>
          </div>
        </div>
        <div className="landingImage">
          <img src="mainlanding.jpg" alt="landingImage" />
        </div>
      </div>
      <div className="backgroundClass"></div>
    </section>
  );
}

export default Landingpage;
